import { html, nothing, unsafeCSS, type CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { LibElement } from '../lib-element';
import '../button/lib-button';
import '../icon/lib-icon';
import notificationCss from './lib-global-notification.css';

@customElement('lib-global-notification')
export class LibGlobalNotification extends LibElement {
  protected override get hostFocusSelector(): string {
    return !this.dismissed && (this.showClose ?? this.severity !== 'error')
      && !this.querySelector('[slot="close"]') ? 'lib-button' : '';
  }
  static override readonly styles: CSSResultGroup = [LibElement.hostStyles, unsafeCSS(notificationCss)];

  @property({ attribute: 'close-label' }) closeLabel = 'Close';
  @property({ reflect: true }) severity = 'information';
  @property({ attribute: 'icon-url' }) iconUrl = '';
  @property({ attribute: 'show-close', converter: value => value === null ? undefined : value !== 'false' }) showClose?: boolean;
  @property() text = '';
  @property({ type: Boolean, reflect: true }) dismissed = false;

  override render() {
    let icon = 'warning';
    if (this.severity === 'success') icon = 'circle-tick-sign';
    else if (this.severity === 'information') icon = 'information_circle';
    return html`
      <div class="headline">
        <lib-icon aria-hidden="true" icon-url=${this.iconUrl || new URL(`../wago-icons-svg/${icon}.svg`, import.meta.url).href}></lib-icon>
        <div class="text"><slot>${this.text}</slot></div>
      </div>
      ${(this.showClose ?? this.severity !== 'error') ? html`
        <slot name="close">
          <lib-button variant="tertiary" aria-label=${this.closeLabel} @click=${this.close}>
            <lib-icon icon-url=${new URL('../wago-icons-svg/btn-close.svg', import.meta.url).href}></lib-icon>
          </lib-button>
        </slot>` : nothing}
    `;
  }

  override updated() {
    if (!this.hasAttribute('role') || this.role === 'status' || this.role === 'alert') {
      this.role = this.severity === 'error' ? 'alert' : 'status';
    }
  }

  private close() {
    this.dismissed = true;
    this.emit('lib-close');
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'lib-global-notification': LibGlobalNotification;
  }
}
